import { SxProps, Theme } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

/** Compact 32px input treatment shared by the interactive question cards. */
export function getInteractiveMessageInputSx(
  borderColor: string
): SxProps<Theme> {
  return {
    '& .MuiOutlinedInput-input': {
      px: 1,
      py: 0.875,
      '&::placeholder': {
        color: COLORS.TEXT.SECONDARY,
        opacity: 1,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor,
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      '&:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline':
        {
          borderColor: COLORS.GRAY[500],
          borderWidth: '1px',
        },
    },
  };
}
